export const SAMPLE_IMAGE_GAP = 16;

export const CHART_HEIGHT = 600;

export const CHART_EXPORT_WIDTH = 1000;
